import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import JourneyMapListPage from './JourneyMap/JourneyMapListPage';
import JourneyMapDetailPage from './JourneyMap/JourneyMapDetailPage';

const EnablementRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<JourneyMapListPage />} />
      <Route path="journey-map/:id" element={<JourneyMapDetailPage />} />

      <Route path="*" element={<Navigate to="/enablement" replace />} />
    </Routes>
  );
};

export default EnablementRoutes;